export default __webpack_public_path__ + "static/media/compliance-graphic.853912a8.png";